import { CircleCheck, Hammer, Rocket } from "lucide-react";

/**
 * Stand der Plattform an einer Stelle. Lesen Startleiste, Warteliste,
 * Login-Hinweis, Kontaktseite und die häufigen Fragen. Bei jedem Fortschritt
 * hier anpassen, damit die Website nichts Veraltetes behauptet.
 */
export const STATUS_UPDATED = "Oktober 2026";

/**
 * Startzeitraum. `in` steht mit Präposition da, weil sie je nach Wert
 * wechselt („im Frühjahr 2027“, aber „Anfang 2027“). Eine Startregion wird
 * vorerst bewusst nicht genannt.
 */
export const STATUS_LAUNCH = { when: "Frühjahr 2027", in: "im Frühjahr 2027" };

/** `state`: done | active | next */
export const STATUS_PHASES = [
  {
    state: "done",
    icon: CircleCheck,
    label: "Steht",
    title: "Konzept und Demo",
    text: "Wie Sponsorings eingerichtet, belegt und ausgewertet werden, ist ausgearbeitet. In der Demo könnt ihr es selbst ausprobieren.",
  },
  {
    state: "active",
    icon: Hammer,
    label: "In Arbeit",
    title: "Die Plattform",
    text: "Profile, Suche und Matching, Setup und Erfassung entstehen gerade.",
  },
  {
    state: "next",
    icon: Rocket,
    label: "Als Nächstes",
    title: `Start ${STATUS_LAUNCH.in}`,
    text: "Die ersten Vereine und Unternehmen legen los. Wer auf der Warteliste steht, erfährt es zuerst.",
  },
];
